// Where the user opened the Reassign Visits flow from.
export enum EntrySource {
    VisitActionsMenu = 'visit_actions_menu',
    BulkClinicianAssignmentTable = 'bulk_clinician_assignment_table',
    BulkServicesAssignmentTable = 'bulk_services_assignment_table',
    VisitRequestActionsMenu = 'visit_request_actions_menu',
    EditShift = 'edit_shift',
    EditShiftBlock = 'edit_shift_block',
    CreateShiftBlock = 'create_shift_block',
    VisitDetailsPage = 'visit_details_page',
    PatientCareTeamUpdate = 'patient_care_team_update',
    PatientEpisodeVisitsSection = 'patient_episode_visits_section',
    ShiftBlockRequestReview = 'shift_block_request_review',
    DashboardWorkQueue = 'dashboard_work_queue',
    // Call site didn't tag the entry source. Fallback bucket.
    Untagged = 'untagged',
}
